
export interface AlertSettings {
    weeklyMatchesLimit: number;
    monthlyMatchesLimit: number;
    bagelsLimit: number;
    bestBroWinRate: number;
    bestBroMatches: number;
    emailAlertsEnabled: boolean;
    emailRecipient: string;
    // New field
    spreeLimit?: number;
}


export interface PlayerStatistics {
    // API returns camelCase from Drizzle
    gamesPerWeek?: number;
    gamesPerMonth?: number;
    bagels?: number;
    currentSpree?: number;

    // Legacy/Internal snake_case support (optional)
    games_per_week?: number;
    games_per_month?: number;
    current_spree?: number;

    // Best Partner (Flat fields from API)
    allTimeBestPartnerName?: string;
    allTimeBestPartnerWinRate?: number;
    allTimeBestPartnerMatches?: number;

    // Legacy nested object
    all_time_best_partner?: {
        name: string;
        win_rate: number;
        matches: number;
    };
}

export function getActiveAlerts(stats: PlayerStatistics | undefined, settings: AlertSettings): string[] {
    if (!stats || !settings) return [];

    const warnings: string[] = [];

    // Handle both camelCase (API) and snake_case (Internal)
    const gamesPerWeek = stats.gamesPerWeek ?? stats.games_per_week ?? 0;
    const gamesPerMonth = stats.gamesPerMonth ?? stats.games_per_month ?? 0;
    const bagels = stats.bagels ?? 0;

    // Handle Spree (Winning or Losing streaks)
    // Checks absolute value against the configured limit
    const currentSpree = stats.currentSpree ?? stats.current_spree ?? 0;
    const spreeLimit = settings.spreeLimit || 10;

    if (Math.abs(currentSpree) >= spreeLimit) {
        const type = currentSpree > 0 ? "Winning" : "Losing";
        warnings.push(`${type} Spree: ${Math.abs(currentSpree)} (Limit: ${spreeLimit})`);
    }

    if (gamesPerWeek > settings.weeklyMatchesLimit) {
        warnings.push(`Matches/week: ${gamesPerWeek} > ${settings.weeklyMatchesLimit}`);
    }

    if (gamesPerMonth > settings.monthlyMatchesLimit) {
        warnings.push(`Matches/month: ${gamesPerMonth} > ${settings.monthlyMatchesLimit}`);
    }

    if (bagels > settings.bagelsLimit) {
        warnings.push(`Bagels: ${bagels} > ${settings.bagelsLimit}`);
    }

    // Handle Best Partner (Check flat first, then nested)
    let bestPartnerName = stats.allTimeBestPartnerName;
    let bestPartnerWinRate = stats.allTimeBestPartnerWinRate;
    let bestPartnerMatches = stats.allTimeBestPartnerMatches;

    if (!bestPartnerName && stats.all_time_best_partner) {
        bestPartnerName = stats.all_time_best_partner.name;
        bestPartnerWinRate = stats.all_time_best_partner.win_rate;
        bestPartnerMatches = stats.all_time_best_partner.matches;
    }

    if (bestPartnerName && bestPartnerWinRate !== undefined && bestPartnerMatches !== undefined) {
        if ((bestPartnerWinRate * 100) > settings.bestBroWinRate &&
            bestPartnerMatches > settings.bestBroMatches) {
            warnings.push(`Best Bro: ${bestPartnerName} (Win Rate: ${(bestPartnerWinRate * 100).toFixed(1)}%)`);
        }
    }

    return warnings;
}
